import { Translations } from "@aidkitorg/i18n/lib"

// This will get you a readable payment method name from a payment type string.
// Method is different than payment kind - for example, givecard_load would be the payment kind, 
// but the payment method could either be a physical card or a virtual card.
export const paymentToReadablePaymentMethod = (paymentType: string, L: Translations) => {
  if (paymentType.includes('ach')) {
    return 'Dwolla ACH';
  }
  if (paymentType === 'givecard_rtp') {
    return 'Givecard Real-time Payments';
  }
  const cardType = paymentType.includes('usio') 
    ? 'USIO' 
    : paymentType.includes('givecard') 
      ? 'Givecard' : paymentType.includes('usbank') ? 'USBank' : 'Unknown';
  if (paymentType.includes('mail') || paymentType.includes('pickup')) {
    return L.payments.physical_card.replace('$type', cardType);
  }
  if (paymentType.includes('virtual')) {
    return L.payments.virtual_card.replace('$type', cardType);
  }
  if (paymentType.includes('load') || cardType !== 'Unknown') {
    return L.payments.generic_card.replace('$type', cardType);
  }
  return L.payments.not_yet_selected;
}

// Readable payment kind name from a payment type string.
export const paymentTypeToString = (paymentType: string, withdrawal?: boolean) => {
  switch(paymentType) {
    case 'ach':
    case 'dwolla_float_ach_grant': 
      return 'ACH'
    case 'usio_mail':
    case 'usio_mailed_grant':
      return 'USIO Mailed Card'
    case 'usio':
    case 'usio_pickup':
    case 'usio_virtual':
    case 'load_usio_card':
      return withdrawal ? 'USIO Card Withdrawal' : 'USIO Card Load'
    case 'western_union_grant':
      return 'Western Union Grant'
    case 'screener_payment':
      return 'Screener Payment'
    case 'givecard_mail':
      return 'Givecard Mailed Card'
    case 'givecard_rtp':
      return 'Givecard Real-time Payment'
    case 'usbank_card_mail':
      return 'US Bank Mailed Card'
    case 'usbank_card_load':
      return withdrawal ? 'US Bank Card Withdrawal' : 'US Bank Card Load'
    case 'givecard_virtual':
      return 'Givecard Virtual Card'
    case 'givecard_load':
      return withdrawal ? 'Givecard Card Withdrawal' : 'Givecard Card Load'
    default:
      return paymentType;
  }
}
